import gql from "graphql-tag";

export const saveEmailTemplateMutation = gql`
    mutation SaveEmailTemplate($emailTemplate: EmailTemplateInput!) {
    communication {
        saveEmailTemplate(emailTemplate: $emailTemplate) {
            id
            templateName
            templateDetails {
                emailBody
                unlayerJsonString
                correspondenceName
                emailFromID
                emailTo
                emailCC
                emailCCAddress
                emailBcc
                emailBccAddress
                cCAddressOnlyFirst
                bCCAddressOnlyFirst
                emailSubject
                viewOnWeb
                copyToCorrespondence
                temporaryAttachmentFolder
            }
        }
    }
}`;
